if (!customElements.get("collection-accordion")) {
  class CollectionAccordion extends HTMLElement {
    connectedCallback() {
      this.keepAllOpen = this.dataset.keepAllOpen === "true";
      this.items = Array.from(
        this.querySelectorAll(".collection-accordion__item")
      );

      this.items.forEach((item) => {
        const toggle = item.querySelector(".collection-accordion__toggle");
        if (!toggle) return;
        toggle.addEventListener("click", () => this.toggleItem(item));
      });
    }

    toggleItem(item) {
      const isOpen = item.classList.contains("is-open");

      if (!this.keepAllOpen) {
        this.items.forEach((other) => {
          if (other !== item) this.setOpen(other, false);
        });
      }

      this.setOpen(item, !isOpen);
    }

    setOpen(item, open) {
      item.classList.toggle("is-open", open);
      const toggle = item.querySelector(".collection-accordion__toggle");
      if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }
  }

  customElements.define("collection-accordion", CollectionAccordion);
}

(function () {
  const ADDED_HOLD_MS = 2000;
  const FADE_MS = 350;

  function showAddedState(button) {
    const label = button.querySelector(".collection-accordion__add-label");
    if (!label || button.disabled) return;

    const defaultLabel =
      label.dataset.defaultLabel || label.textContent.trim() || "Add";
    const addedLabel = label.dataset.addedLabel || "Added!";
    label.dataset.defaultLabel = defaultLabel;

    if (button._addedResetTimer) clearTimeout(button._addedResetTimer);
    if (button._addedFadeTimer) clearTimeout(button._addedFadeTimer);

    button.classList.remove("is-label-fade");
    label.textContent = addedLabel;
    button.classList.add("is-added");

    button._addedResetTimer = setTimeout(() => {
      button.classList.add("is-label-fade");
      button._addedFadeTimer = setTimeout(() => {
        label.textContent = defaultLabel;
        button.classList.remove("is-added", "is-label-fade");
      }, FADE_MS);
    }, ADDED_HOLD_MS);
  }

  function onVariantAdded(event) {
    const form = event.detail?.formElement;
    if (!form) return;

    const button = form
      .closest(".collection-accordion__card-form")
      ?.querySelector(".collection-accordion__add-btn");
    if (!button) return;

    const reveal = () => showAddedState(button);

    if (button.classList.contains("loading")) {
      const observer = new MutationObserver(() => {
        if (!button.classList.contains("loading")) {
          observer.disconnect();
          reveal();
        }
      });
      observer.observe(button, { attributes: true, attributeFilter: ["class"] });
      // Safety if loading class is already gone before observe fires
      setTimeout(() => {
        if (!button.classList.contains("loading")) {
          observer.disconnect();
          reveal();
        }
      }, 0);
      return;
    }

    reveal();
  }

  document.addEventListener("variant:add", onVariantAdded);
})();
